const bad_words = [
  "about",
  "aboutu",
  "abuse",
  "access",
  "account",
  "accounts",
  "activate",
  "add",
  "address",
  "adm",
  "admin",
  "admindashboard",
  "administration",
  "administrator",
  "ads",
  "adsense",
  "adult",
  "adword",
  "advertising",
  "affiliate",
  "affiliatepage",
  "affiliates",
  "ajax",
  "analytic",
  "analytics",
  "android",
  "a",
  "anon",
  "anonymous",
  "answer",
  "api",
  "app",
  "appengine",
  "application",
  "appnew",
  "apple",
  "apps",
  "arabic",
  "archive",
  "archives",
  "as",
  "asdf",
  "atom",
  "auth",
  "authentication",
  "avatar",
  "awadhi",
  "azerbaijani",
  "backup",
  "banner",
  "banners",
  "bengali",
  "beta",
  "bhojpuri",
  "billing",
  "bin",
  "blog",
  "blogs",
  "blogsearch",
  "board",
  "bot",
  "bots",
  "burmese",
  "business",
  "cache",
  "cadastro",
  "calendar",
  "campaign",
  "cancel",
  "careers",
  "cart",
  "cas",
  "catalog",
  "cgi",
  "changelog",
  "chart",
  "chat",
  "checkout",
  "chinese",
  "ci",
  "cia",
  "client",
  "cliente",
  "cname",
  "code",
  "codereview",
  "comercial",
  "compare",
  "compras",
  "config",
  "configuration",
  "confirm",
  "confirmation",
  "connect",
  "contact",
  "contact_u",
  "contactu",
  "content",
  "controlpanel",
  "coon",
  "core",
  "corp",
  "countrie",
  "country",
  "cp",
  "cpanel",
  "crap",
  "contest",
  "create",
  "cs",
  "css",
  "cv",
  "damn",
  "dashboard",
  "data",
  "db",
  "delete",
  "demo",
  "deploy",
  "deployment",
  "desktop",
  "design",
  "designer",
  "dev",
  "devel",
  "developement",
  "developer",
  "development",
  "dick",
  "dike",
  "dildo",
  "dir",
  "direct_messages",
  "directory",
  "discussion",
  "dl",
  "doc",
  "docs",
  "document",
  "documentation",
  "domain",
  "donate",
  "download",
  "downloads",
  "dutch",
  "ecommerce",
  "edit",
  "editor",
  "email",
  "employment",
  "enable",
  "encrypted",
  "engine",
  "error",
  "errorlog",
  "english",
  "enterprise",
  "facebook",
  "faq",
  "farsi",
  "favorite",
  "favorites",
  "fbi",
  "feature",
  "feed",
  "feedback",
  "feedburner",
  "feedproxy",
  "feeds",
  "file",
  "files",
  "fleet",
  "fleets",
  "flog",
  "folder",
  "follow",
  "followers",
  "following",
  "forgotpassword",
  "forum",
  "forums",
  "free",
  "french",
  "friend",
  "friends",
  "ftp",
  "fuck",
  "fudgepacker",
  "fun",
  "fusion",
  "gadget",
  "gadgets",
  "games",
  "gan",
  "gear",
  "german",
  "gettingstarted",
  "gist",
  "git",
  "gitlab",
  "github",
  "gmail",
  "google",
  "goto",
  "group",
  "groups",
  "guest",
  "gujarati",
  "hakka",
  "hausa",
  "help",
  "hindi",
  "home",
  "homepage",
  "host",
  "hosting",
  "hostmaster",
  "hostname",
  "hpg",
  "html",
  "htrnl",
  "http",
  "httpd",
  "https",
  "i",
  "idea",
  "ideas",
  "image",
  "images",
  "imap",
  "img",
  "imulus",
  "index",
  "indice",
  "info",
  "information",
  "intranet",
  "invitations",
  "invite",
  "ipad",
  "iphone",
  "irc",
  "is",
  "it",
  "item",
  "italian",
  "japanese",
  "java",
  "javanese",
  "javascript",
  "jenkin",
  "jenkins",
  "jinyu",
  "job",
  "jobs",
  "join",
  "js",
  "json",
  "kannada",
  "knowledgebase",
  "korean",
  "lab",
  "language",
  "languages",
  "list",
  "lists",
  "local",
  "locale",
  "location",
  "log",
  "login",
  "logout",
  "logs",
  "mail",
  "mail1",
  "mail2",
  "mail3",
  "mail4",
  "mail5",
  "mailer",
  "mailing",
  "maithili",
  "malayalam",
  "manage",
  "manager",
  "mandarin",
  "map",
  "maps",
  "marathi",
  "marketing",
  "master",
  "me",
  "media",
  "message",
  "messenger",
  "microblog",
  "microblogs",
  "mine",
  "mis",
  "misc",
  "mms",
  "mob",
  "mobile",
  "model",
  "money",
  "movie",
  "movies",
  "mp3",
  "msg",
  "msn",
  "music",
  "musicas",
  "mx",
  "my",
  "mysql",
  "mystore",
  "name",
  "named",
  "net",
  "network",
  "new",
  "news",
  "newsletter",
  "nick",
  "nickname",
  "noc",
  "notes",
  "noticias",
  "ns",
  "ns1",
  "ns10",
  "ns2",
  "ns3",
  "ns4",
  "ns5",
  "ns6",
  "ns7",
  "ns8",
  "ns9",
  "oauth",
  "oauth_clients",
  "offers",
  "old",
  "online",
  "openid",
  "operator",
  "order",
  "orders",
  "org",
  "organizations",
  "oriya",
  "page",
  "pager",
  "pages",
  "panel",
  "panjabi",
  "password",
  "perl",
  "photo",
  "photoalbum",
  "photos",
  "php",
  "pic",
  "pics",
  "place",
  "plans",
  "plugin",
  "plugins",
  "podcast",
  "policy",
  "polish",
  "pop",
  "pop3",
  "popular",
  "portuguese",
  "post",
  "postfix",
  "postmaster",
  "posts",
  "pricing",
  "print",
  "privacy",
  "private",
  "prod",
  "product",
  "production",
  "profile",
  "project",
  "projects",
  "promo",
  "promotion",
  "proxie",
  "proxies",
  "proxy",
  "pub",
  "public",
  "purchase",
  "put",
  "python",
  "q",
  "qr",
  "query",
  "questions",
  "quotes",
  "r",
  "random",
  "ranking",
  "read",
  "readme",
  "recent",
  "recover",
  "recovery",
  "redirect",
  "ref",
  "referer",
  "refresh",
  "register",
  "registration",
  "release",
  "releases",
  "reload",
  "remind",
  "remove",
  "replies",
  "report",
  "reports",
  "repositories",
  "repository",
  "req",
  "request",
  "request_password",
  "reset",
  "reset_password",
  "review",
  "reviews",
  "robot",
  "robots",
  "robotstxt",
  "root",
  "rootadmin",
  "rss",
  "rules",
  "sale",
  "sales",
  "sample",
  "samples",
  "save",
  "school",
  "search",
  "secure",
  "security",
  "send",
  "server",
  "server_info",
  "server_status",
  "service",
  "session",
  "sessions",
  "setting",
  "settings",
  "setup",
  "share",
  "shift",
  "shop",
  "show",
  "signin",
  "signup",
  "site",
  "sitemap",
  "sites",
  "sms",
  "snoop",
  "soap",
  "software",
  "soporte",
  "source",
  "sql",
  "ssh",
  "ssl",
  "ssladmin",
  "ssladministrator",
  "sslwebmaster",
  "stage",
  "staging",
  "start",
  "stat",
  "state",
  "static",
  "stats",
  "status",
  "store",
  "stores",
  "stories",
  "style",
  "styles",
  "styleguide",
  "subdomain",
  "subscribe",
  "subscriptions",
  "sudo",
  "sudu",
  "support",
  "svn",
  "swf",
  "sys",
  "sysadmin",
  "sysadministrator",
  "system",
  "tablet",
  "tablets",
  "tag",
  "tags",
  "tamil",
  "task",
  "tasks",
  "tech",
  "telugu",
  "test",
  "test1",
  "test2",
  "test3",
  "teste",
  "testing",
  "tests",
  "texis",
  "text",
  "theme",
  "themes",
  "trackback",
  "translate",
  "translator",
  "trends",
  "tweet",
  "twitter",
  "type",
  "ua",
  "ug",
  "uk",
  "unfollow",
  "unsubscribe",
  "update",
  "upload",
  "uploader",
  "uploads",
  "upgrade",
  "url",
  "usage",
  "user",
  "username",
  "users",
  "usuario",
  "vendas",
  "ver",
  "verify",
  "version",
  "video",
  "videos",
  "view",
  "views",
  "visitor",
  "watch",
  "weather",
  "web",
  "webmail",
  "webmaster",
  "website",
  "websites",
  "welcome",
  "widget",
  "widgets",
  "wiki",
  "win",
  "windows",
  "word",
  "work",
  "works",
  "world",
  "write",
  "ws",
  "ww",
  "www",
  "www1",
  "www2",
  "www3",
  "www4",
  "www5",
  "www6",
  "www7",
  "wwws",
  "wwww",
  "xfn",
  "xml",
  "xmpp",
  "xpg",
  "xsl",
  "yaml",
  "yml",
  "zh",
  "zh_cn",
  "zh_tw",
  "zhs",
  "zht",
  "zhu",
  "zip",
  "zoom",
  "zz",
  "4r5e", "5h1t", "5hit", "a55", "anal", "anus", "ar5e", "arrse", "arse", "ass", "ass_fucker", "asses", "assfucker", "assfukka", "asshole", "assholes", "asswhole", "a_s_s", "b!tch", "b00bs", "b17ch", "b1tch", "ballbag", "balls", "ballsack", "bastard", "beastial", "beastiality", "bellend", "bestial", "bestiality", "bi+ch", "biatch", "bitch", "bitcher", "bitchers", "bitches", "bitchin", "bitching", "bloody", "blow job", "blowjob", "blowjobs", "boiolas", "bollock", "bollok", "boner", "boob", "boobs", "booobs", "boooobs", "booooobs", "booooooobs", "breasts", "buceta", "bugger", "bum", "bunny fucker", "butt", "butthole", "buttmuch", "buttplug", "c0ck", "c0cksucker", "carpet muncher", "cawk", "chink", "cipa", "cl1t", "clit", "clitoris", "clits", "cnut", "cock", "cock_sucker", "cockface", "cockhead", "cockmunch", "cockmuncher", "cocks", "cocksuck", "cocksucked", "cocksucker", "cocksucking", "cocksucks", "cocksuka", "cocksukka", "cok", "cokmuncher", "coksucka", "coon", "cox", "crap", "cum", "cummer", "cumming", "cums", "cumshot", "cunilingus", "cunillingus", "cunnilingus", "cunt", "cuntlick", "cuntlicker", "cuntlicking", "cunts", "cyalis", "cyberfuc", "cyberfuck", "cyberfucked", "cyberfucker", "cyberfuckers", "cyberfucking", "d1ck", "damn", "dick", "dickhead", "dildo", "dildos", "dink", "dinks", "dirsa", "dlck", "dog_fucker", "doggin", "dogging", "donkeyribber", "doosh", "duche", "dyke", "ejaculate", "ejaculated", "ejaculates", "ejaculating", "ejaculatings", "ejaculation", "ejakulate", "f u c k", "f u c k e r", "f4nny", "fag", "fagging", "faggitt", "faggot", "faggs", "fagot", "fagots", "fags", "fanny", "fannyflaps", "fannyfucker", "fanyy", "fatass", "fcuk", "fcuker", "fcuking", "feck", "fecker", "felching", "fellate", "fellatio", "fingerfuck", "fingerfucked", "fingerfucker", "fingerfuckers", "fingerfucking", "fingerfucks", "fistfuck", "fistfucked", "fistfucker", "fistfuckers", "fistfucking", "fistfuckings", "fistfucks", "flange", "fook", "fooker", "fuck", "fucka", "fucked", "fucker", "fuckers", "fuckhead", "fuckheads", "fuckin", "fucking", "fuckings", "fuckingshitmotherfucker", "fuckme", "fucks", "fuckwhit", "fuckwit", "fudge packer", "fudgepacker", "fuk", "fuker", "fukker", "fukkin", "fuks", "fukwhit", "fukwit", "fux", "fux0r", "f_u_c_k", "gangbang", "gangbanged", "gangbangs", "gaylord", "gaysex", "goatse", "God", "god_dam", "god_damned", "goddamn", "goddamned", "hardcoresex", "hell", "heshe", "hoar", "hoare", "hoer", "homo", "hore", "horniest", "horny", "hotsex", "jack_off", "jackoff", "jap", "jerk_off", "jism", "jiz", "jizm", "jizz", "kawk", "knob", "knobead", "knobed", "knobend", "knobhead", "knobjocky", "knobjokey", "kock", "kondum", "kondums", "kum", "kummer", "kumming", "kums", "kunilingus", "l3i+ch", "l3itch", "labia", "lust", "lusting", "m0f0", "m0fo", "m45terbate", "ma5terb8", "ma5terbate", "masochist", "master_bate", "masterb8", "masterbat*", "masterbat3", "masterbate", "masterbation", "masterbations", "masturbate", "mo_fo", "mof0", "mofo", "mothafuck", "mothafucka", "mothafuckas", "mothafuckaz", "mothafucked", "mothafucker", "mothafuckers", "mothafuckin", "mothafucking", "mothafuckings", "mothafucks", "mother fucker", "motherfuck", "motherfucked", "motherfucker", "motherfuckers", "motherfuckin", "motherfucking", "motherfuckings", "motherfuckka", "motherfucks", "muff", "mutha", "muthafecker", "muthafuckker", "muther", "mutherfucker", "n1gga", "n1gger", "nazi", "nigg3r", "nigg4h", "nigga", "niggah", "niggas", "niggaz", "nigger", "niggers", "nob", "nob jokey", "nobhead", "nobjocky", "nobjokey", "numbnuts", "nutsack", "orgasim", "orgasims", "orgasm", "orgasms", "p0rn", "pawn", "pecker", "penis", "penisfucker", "phonesex", "phuck", "phuk", "phuked", "phuking", "phukked", "phukking", "phuks", "phuq", "pigfucker", "pimpis", "piss", "pissed", "pisser", "pissers", "pisses", "pissflaps", "pissin", "pissing", "pissoff", "poop", "porn", "porno", "pornography", "pornos", "prick", "pricks", "pron", "pube", "pusse", "pussi", "pussies", "pussy", "pussys", "rectum", "retard", "rimjaw", "rimming", "s hit", "s.o.b.", "sadist", "schlong", "screwing", "scroat", "scrote", "scrotum", "semen", "sex", "sh!+", "sh!t", "sh1t", "shag", "shagger", "shaggin", "shagging", "shemale", "shi+", "shit", "shitdick", "shite", "shited", "shitey", "shitfuck", "shitfull", "shithead", "shiting", "shitings", "shits", "shitted", "shitter", "shitters", "shitting", "shittings", "shitty", "skank", "slut", "sluts", "smegma", "smut", "snatch", "son_of_a_bitch", "spac", "spunk", "s_h_i_t", "t1tt1e5", "t1tties", "teets", "teez", "testical", "testicle", "tit", "titfuck", "tits", "titt", "tittie5", "tittiefucker", "titties", "tittyfuck", "tittywank", "titwank", "tosser", "turd", "tw4t", "twat", "twathead", "twatty", "twunt", "twunter", "v14gra", "v1gra", "vagina", "viagra", "vulva", "w00se", "wang", "wank", "wanker", "wanky", "whoar", "whore", "willies", "willy", "xrated", "xxx"
]
const isBadWord = (word) => {
  return bad_words.includes(word);
};

export default isBadWord;
